module.exports = __webpack_public_path__ + "img/img-chart-02.41382fba.png";